import './App.css';
import Home from "./views/Videos";
import About from "./views/About";
import { BrowserRouter, Route, Routes } from 'react-router-dom';
// import ReactLogo from './img/logo.svg';
// import { GlobalStyle } from "./styles/Global.style";
// import './scripts/Global';
// import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <div className="App">
      {/* <GlobalStyle/> */}
      <header>
        <h1 class="logo">Eagle Studios</h1>
        <input type="checkbox" id="nav-toggle" class="nav-toggle"></input>
        <nav>
          <ul>
            <li><a href="/">Video's</a></li>
            <li><a href="/About">Over mij</a></li>
          </ul>
        </nav>
        <label for="nav-toggle" class="nav-toggle-label">
          <span></span>
        </label>
      </header>

      <div class="content">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />}></Route>
            <Route path="/About" element={<About />}></Route>
          </Routes>
        </BrowserRouter>  
      </div>


      {/* <header className="App-header">
        <a href={"/"}>Home</a>
        <a href={"/About"}>About</a>
      </header> */}
    </div>
  );
}

export default App;
